export default "__VITE_ASSET__Bf9_xXwU__"